import clsx from 'clsx';
import { Heading, Text, Types } from '@marriott/mi-ui-library';
import { IMerchandisingHeroBannerContent } from '../organisms/MerchandisingHeroBanner/MerchandisingHeroBanner.types';
import { returnDecodedString, updateClass } from '../utils/helpers';
import { MarkDownText } from './markDown/MarkDown';
const { HeaderTextStyle, headingType, size, tags, ImageAspectRatio, AssetVariation } = Types;
const { H1, H3, H4, H5, H6, WITHOUT_CO_BRAND } = HeaderTextStyle;
const { SIZE_16x9, SIZE_2X1 } = ImageAspectRatio;

const getElement = (headertextstyle: string) => {
  switch (headertextstyle) {
    case H1:
      return tags.h1;
    case H3:
      return tags.h3;
    case H4:
      return tags.h4;
    case H5:
      return tags.h5;
    case H6:
      return tags.h6;
    default:
      return tags.h2;
  }
};

/**
 *
 * @param props
 * @returns eyeBrowText, Header & description on conditional basis
 */
export const MerchandisingHeroBannerContent = (props: IMerchandisingHeroBannerContent) => {
  const {
    headertextstyle,
    headerMedium,
    descriptionLong,
    isVerticalImage,
    heroSize,
    isLightScrim,
    assetsVariation,
    logo,
    font_icon,
    cobrandmathhero,
    eyebrowText,
    copyBlockWidthContainerClass,
    isMerchHero3X1 = false,
    isVariationsAvailable = false,
  } = props;

  const headingTextClassName = clsx(
    isMerchHero3X1 ? '' : 'hb__heading',
    isVerticalImage ? 'vertical__image__hero-' + heroSize?.replace(':', 'x') : '',
    isLightScrim ? '' : 't-color-inverse',
    heroSize === SIZE_16x9 || heroSize === SIZE_2X1 ? '' : isMerchHero3X1 ? '' : ' mb-0',
    heroSize === SIZE_16x9 && headertextstyle === WITHOUT_CO_BRAND && !isVerticalImage
      ? updateClass(' hb__heading-cobrand', '', isMerchHero3X1)
      : '',
    (assetsVariation === AssetVariation.IMAGE && logo?.imageSrc && !cobrandmathhero) ||
      (assetsVariation === AssetVariation.FONT_ICON && font_icon && !cobrandmathhero)
      ? updateClass(' hb__heading__assetsVariation mb-lg-2', '', isMerchHero3X1)
      : '',
    !isVerticalImage && cobrandmathhero ? updateClass(' hb__heading__cobrandMathHero mb-lg-3', '', isMerchHero3X1) : '',
    isMerchHero3X1 ? 'mb-2 mb-md-1 mb-xl-2' : ''
  );

  const subHeadingTextClassName = clsx(
    isMerchHero3X1 ? 'mb-0' : 'hb__subheading mb-0',
    isVerticalImage ? 'vertical__image__hero-' + heroSize?.replace(':', 'x') : '',
    isLightScrim ? '' : 't-color-inverse',
    heroSize === SIZE_16x9 || heroSize === SIZE_2X1 ? '' : updateClass(' mt-1 mb-0', '', isMerchHero3X1),
    (assetsVariation === AssetVariation.IMAGE && logo?.imageSrc && !cobrandmathhero) ||
      (assetsVariation === AssetVariation.FONT_ICON && font_icon && !cobrandmathhero)
      ? updateClass(' hb__subheading__assetsVariation', '', isMerchHero3X1)
      : '',
    !isVerticalImage && cobrandmathhero ? updateClass(' hb__subheading__cobrandMathHero', '', isMerchHero3X1) : '',
    isMerchHero3X1 ? 'mb-0' : ''
  );

  const showDescription = descriptionLong ? (isMerchHero3X1 ? (isVariationsAvailable ? false : true) : true) : false;

  return (
    <>
      {Boolean(!isVerticalImage && eyebrowText && !logo?.imageSrc) && (
        <div className="row">
          <div className={clsx(isMerchHero3X1 ? 'p-0 pl-2' : copyBlockWidthContainerClass)}>
            <Text
              copyText={eyebrowText}
              fontSize={size.extraSmall}
              customClass={clsx(
                isMerchHero3X1 ? (isVariationsAvailable ? 'mb-2 mb-md-1' : 'mb-2 mb-md-1 mb-xl-2') : 'mb-1 mb-lg-2',
                {
                  't-overline-normal t-color-black': isLightScrim,
                  't-overline-inverse-normal': !isLightScrim,
                }
              )}
              element={tags.div}
            />
          </div>
        </div>
      )}
      {Boolean(headerMedium) && (
        <div className="row">
          <div className={clsx(isMerchHero3X1 ? 'p-0 pl-2' : copyBlockWidthContainerClass)}>
            <MarkDownText
              variation={headingType.title}
              textContent={headerMedium}
              className={clsx(headingTextClassName, isMerchHero3X1 ? 't-title-s' : '')}
              fallback={
                <Heading
                  variation={headingType.title}
                  element={getElement(headertextstyle)}
                  titleText={returnDecodedString(headerMedium)}
                  customClass={clsx(headingTextClassName, isMerchHero3X1 ? 't-title-s' : '')}
                />
              }
            />
          </div>
        </div>
      )}
      {showDescription &&
        heroBannerDescriptionContent(
          isMerchHero3X1,
          copyBlockWidthContainerClass,
          descriptionLong,
          subHeadingTextClassName
        )}
    </>
  );
};

export const heroBannerDescriptionContent = (
  isMerchHero3X1: boolean,
  copyBlockWidthContainerClass: string,
  descriptionLong: string,
  subHeadingTextClassName: string
) => {
  return (
    <div className="row">
      <div className={clsx(isMerchHero3X1 ? 'p-0 pl-2' : copyBlockWidthContainerClass)}>
        <Heading
          variation={headingType.subtitle}
          element={tags.paragraph}
          fontSize={size.medium}
          titleText={returnDecodedString(descriptionLong)}
          customClass={clsx(subHeadingTextClassName, isMerchHero3X1 ? 't-font-m' : '')}
        />
      </div>
    </div>
  );
};
